import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
// Data Tables
import jQuery from "jquery";
import "datatables.net-bs4";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-buttons/js/buttons.flash";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";

import { NOTIFY, DEFAULTS } from "common/config";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  CONFIRMS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import { ApiMasters } from "apihandlers//masters/masters";
import ExcelGrid from "components/Custom/ExcelGrid";
const ApiReportsHandler = new ApiReports();
const ApiMastersHandler = new ApiMasters();

const $ = jQuery;

const VehiclesRegister = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<any>({});
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "indentNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Indent Number",
      width: "20%",
    },
    {
      key: "referenceNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Reference Number",
      width: "20%",
    },
    {
      key: "vehicleNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Vehicle Number",
      width: "10%",
    },
    {
      key: "driverUsername",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Driver Username",
      width: "10%",
    },
    {
      key: "paymentMadeOn",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Payment Date",
      width: "10%",
    },
    {
      key: "enteredDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Entered Date",
      width: "10%",
    },
    {
      key: "paymentAmount",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Payment Amount",
      width: "10%",
      renderSum: true,
    },
    {
      key: "chargeType",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Charge Type",
      width: "10%",
    },
    {
      key: "chargesCategoryName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Charges Category Name",
      width: "10%",
    },
    {
      key: "paymntType",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Payment Type",
      width: "10%",
    },
    {
      key: "fuelQuantity",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Fuel Quantity",
      width: "10%",
    },
    {
      key: "remarks",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Remarks",
      width: "10%",
    },
    {
      key: "activeStatus",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "Status",
      width: "10%",
    },
  ];

  useEffect(() => {
    if (loading) {
      getMasterData();
    }
  }, [loading]);

  const getMasterData = () => {
    const args = { shortMode: true };
    ApiMastersHandler.getVehicles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].vehicleNumber,
          });
        }
        setMasters(list);
        setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const id = masterRef.current.selectedValue.id;
    if (!id) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.DATA_IS_EMPTY);
      return;
    }
    const vehicle = masterRef.current.selectedValue.id;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.VEHICLE +
        ":" +
        vehicle +
        "\n" +
        LABELS.FROM_DATE +
        ":" +
        fromDt +
        "\n" +
        LABELS.TO_DATE +
        ":" +
        toDt
    );
    const args = {
      reportType: "excel",
      fromDt,
      toDt,
      id: -1,
      vehicleId: id,
      // driverId: -1,
    };
    // if ($.fn.dataTable.isDataTable("#reportGrid")) {
    //   let table = $("#reportGrid").DataTable();
    //   table.destroy();
    // }
    // if ($("#reportGrid")) {
    //   $("#reportGrid").empty();
    // }
    let errors = [];
    if (fromDt == "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt == "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    setChartData(null);
    ApiReportsHandler.getVehicelLedger(args).then((res) => {
      // console.log("getUserLogReport:", args);
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  const masterRef: any = useRef();

  // console.log("elist:", masters);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.VEHICLE_REGISTER_REPORT}</li>
        </ul>
        <h4>{TITLES.VEHICLE_REGISTER_REPORT}</h4>
        <p className="SubTitles">{SUB_TITLES.VEHICLE_REGISTER_REPORT}</p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 5,
                marginBottom: 10,
                width: "40%",
              }}
            >
              <label>{"Select Vehicle :"}</label>
              <AutoComplete
                id={"masters"}
                list={masters}
                childRef={masterRef}
                defaultValue={{ id: -1, label: "All" }}
              />
            </div>
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 0,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  loading={!chartData}
                />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"vehicleRegisteReport"}
              title={LABELS.VEHICLE_REGISTER_REPORT}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(VehiclesRegister);
